"use client";

// components
import HeroSection from "@/components/HeroSection ";
import ProductNavigationTabs from "@/components/ProductNavigationTabs";
import HotelSearchFormWrapper from "@/components/pages/hotel/searchForm";

// utils
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { getCdnImagePath } from "@/utils/bus/getCdnImagePath";

const HeaderSection = ({
  mainTitle,
  customTitle,
  customMobileTitle,
  titleClassName = "",
  mobileTitleClassName = "",
  navigationBar = true,
  initialLocationCode = null,
  backgroundWrapperClassName,
  backgroundImageClassName,
  backgroundImage = null,
  hasHeaderNavigation = false,
  wrapperClassName = "",
  contentClassName = "",
}) => {
  const t = useTranslationDetector("hotel");

  return (
    <HeroSection
      hasHeaderNavigation={hasHeaderNavigation}
      className={wrapperClassName}
      mainTitle={mainTitle}
      title={
        customTitle || (
          <>
            {t("heroTitleLine1")}
            <br />
            {t("heroTitleLine2")}
          </>
        )
      }
      titleClassName={titleClassName}
      mobileTitleClassName={mobileTitleClassName}
      mobileTitle={customMobileTitle || t("heroMobileTitle")}
      navigationComponent={navigationBar && ProductNavigationTabs}
      searchComponent={() => (
        <HotelSearchFormWrapper
          scrollToForm
          initialLocationCode={initialLocationCode}
          autoSelectFirstWhenClosed
        />
      )}
      backgroundImage={
        backgroundImage || {
          desktop: "https://cdn.turna.com/saka/hotel/desktop-background.png",
          tablet:
            "https://cdn.turna.com/saka/hotel/desktop-background-small.png",
          mobile: getCdnImagePath("/saka/hotel/hotel-home-banner-mobile.png"),
        }
      }
      backgroundWrapperClassName={backgroundWrapperClassName}
      backgroundImageClassName={backgroundImageClassName}
      contentContainerClassName="container"
      contentClassName={contentClassName}
      // titleContainerClassName="max-lg:container"
    />
  );
};

export default HeaderSection;
